var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCheckIn = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.49998 0H5.49998C5.36737 0 5.24019 0.0526784 5.14643 0.146447C5.05266 0.240215 4.99998 0.367392 4.99998 0.5V3H2.49998C2.40399 3.0001 2.31006 3.02782 2.22941 3.07986C2.14876 3.1319 2.08478 3.20606 2.04514 3.29347C2.00549 3.38089 1.99184 3.47787 2.00582 3.57283C2.0198 3.66779 2.06082 3.75672 2.12398 3.829L5.62398 7.829C5.67091 7.88254 5.72873 7.92544 5.79357 7.95483C5.85841 7.98422 5.92879 7.99942 5.99998 7.99942C6.07117 7.99942 6.14155 7.98422 6.20639 7.95483C6.27123 7.92544 6.32905 7.88254 6.37598 7.829L9.87598 3.829C9.93914 3.75672 9.98016 3.66779 9.99414 3.57283C10.0081 3.47787 9.99447 3.38089 9.95482 3.29347C9.91518 3.20606 9.8512 3.1319 9.77055 3.07986C9.6899 3.02782 9.59597 3.0001 9.49998 3H6.99998V0.5C6.99998 0.367392 6.9473 0.240215 6.85353 0.146447C6.75977 0.0526784 6.63259 0 6.49998 0V0Z",
    fill: "#8094A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 10H2V7H0V10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H10C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10V7H10V10Z",
    fill: "#8094A8"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckIn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-in.da16b23e.svg";
export { ForwardRef as ReactComponent };